<template>
  <v-row>
    <v-col cols="auto" v-for="(item, index) in items" :key="index">
      <KpiSingleComponent v-bind="item">
        <template v-slot:default="{closeDropdown}">
          <slot :name="item.dropdownSlot" :dropdownData="item.dropdownData" :index="index" :closeDropdown="closeDropdown"></slot>
        </template>
      </KpiSingleComponent>
    </v-col>
  </v-row>
</template>

<script>
import KpiSingleComponent from "@/components/lead/kpi/KpiSingleComponent";

export default {
  name: "KpiListComponent",
  components: {KpiSingleComponent},
  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped>

</style>
